import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home';
import Contact from '@/pages/Contact';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/residential',
      name: 'Residential',
      component: () => import('@/pages/Residential')
    },
    {
      path: '/commercial',
      name: 'Commercial',
      component: () => import('@/pages/Commercial')
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    // {
    //   path: '*',
    //   name: 'CatchAll',
    //   component: Home
    // }
  ],
  scrollBehavior (to, from, savedPosition) {
    return{ x: 0, y: 0 }
  }
});

export default router;